import React, { useEffect, useState } from 'react'
import * as $ from 'jquery';
import { connect, useDispatch } from 'react-redux'
import { initializePatientTemplateAttributes } from '../../../../itrust_common/components/HelperFunctions'
import { useHistory } from 'react-router-dom';
import { quickActions } from '../../../../redux/actions/dashboard/quickActionActions';
import { appointmentEdit } from '../../../../redux/actions/appointmentActions';
import Alert from '../../../../itrust_common/components/Alert';
import { patientTemplateLoad } from '../../../../redux/actions/public/PatientTemplateActions';

function QuickActions(props) {
  const { currentStoreId, currentUserRole, timeSlotFrequency, currentUserActions, whatsAppConfig, quickActionOrder, storeSpecificPatients } = props
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (storeSpecificPatients !== undefined) {
      let items = quickActionsData
      let index = items.findIndex(item => item.name == 'patient')
      items.splice(index, 1, { ...items[index], storeId: storeSpecificPatients })
      setQuickActionsData([...items])
    }
  }, [storeSpecificPatients])

  useEffect(() => {
    if (whatsAppConfig?.visible) {
      let items = quickActionsData
      items.splice(6, 0, whatsappAction)
      setQuickActionsData([...items])
    }
  }, [whatsAppConfig?.visible])

  const handlePatientAction = async () => {
    let patientTemplate = await dispatch(patientTemplateLoad());
    patientTemplate = patientTemplate.value.data.patient_template
    var patientData = initializePatientTemplateAttributes(patientTemplate?.personal_information)
    dispatch(quickActions({ select_patient_modal: 'patient', patient: { ...patientData, id: 'New' } }))
    // setTimeout(() => $('#quickActionPatientForm-modal').modal('show'), 500);
    setTimeout(() => $('#fullModePatient-modal').modal({ backdrop: 'static', keyboard: false }), 300);
  }

  const handleAddContactLens = () => {
    if (currentStoreId) {
      history.push(`/organisation/stores/${currentStoreId}/settings/order-inventory/contact-lens`)
    }
    else {
      Alert.warning("Please select store from top dropdown.")
    }
  }

  const handleAddInsurance = () => {
    history.push(`/settings/insurance/vision-insurance`)
  }

  const handlePatientSelect = (selectedAction) => {
    dispatch(quickActions({ select_patient_modal: selectedAction }))
    $('#patientSelect-modal').modal('show');
  }

  const handleAddStoreContact = () => {
    if (currentStoreId) {
      history.push(`/organisation/stores/${currentStoreId}/settings/contact`)
    }
    else {
      Alert.warning("Please select store from top dropdown.")
    }
  }

  const handleAppointmentAction = () => {
    dispatch(quickActions({ select_patient_modal: 'appointment' }))
    const appointmentData = { comment: '', start_time: new Date(), end_time: new Date(new Date().getTime() + timeSlotFrequency * 60000), store_id: currentStoreId, appointment_type: 'in_office' }
    dispatch(appointmentEdit('New', appointmentData));
    setTimeout(() => $('#appointmentForm-modal').modal({ backdrop: 'static', keyboard: false }), 300);
  }

  const handleCheckStoreDependency = (action) => {
    return () => {
      if (action.storeId && !currentStoreId) {
        Alert.warning("Please select store from top dropdown.")
      } else {
        action.onclick()
      }
    }
  }

  let QuickActions = [
    { title: 'Order', name: 'order', icon: 'la-shopping-cart', onclick: () => handlePatientSelect('order'), storeId: true },
    { title: 'New Patient', name: 'patient', icon: 'la-user-plus', onclick: handlePatientAction, storeId: storeSpecificPatients },
    { title: 'Appointment', name: 'appointment', icon: 'la-calendar', onclick: handleAppointmentAction, storeId: true },
    { title: 'Exam', name: 'exam', icon: 'la-stethoscope', onclick: () => handlePatientSelect('exam'), storeId: true },
    { title: 'Prescription', name: 'prescription', icon: 'la-file-alt', onclick: () => handlePatientSelect('prescription'), storeId: true },
    { title: 'Text Message', name: 'send_text_message', icon: 'la-sms', onclick: () => handlePatientSelect('sms'), storeId: true },
    { title: 'Phone Call', name: 'make_phone_call', icon: 'la-phone-volume', onclick: () => handlePatientSelect('make_call'), storeId: true },
    { title: 'Contact Lens', name: 'add_contact_lens', icon: 'la-glasses', notVisibleTo: ['non_admin'], onclick: handleAddContactLens, storeId: true },
    { title: 'Insurance', name: 'add_insurance', icon: 'la-medkit', onclick: handleAddInsurance, notVisibleTo: ['admin', 'non_admin'] },
    { title: 'Contact', name: 'add_contact', icon: 'la-user-circle', notVisibleTo: ['non_admin'], onclick: handleAddStoreContact, storeId: true },
    // { title: 'Create Quick Sale', name: 'create_quick_sale', icon: 'la-dollar-sign' },
  ]

  const whatsappAction = { title: 'WhatsApp', name: 'whatsapp', icon: 'la-whatsapp', onclick: () => handlePatientSelect('whatsapp'), storeId: true }

  const [quickActionsData, setQuickActionsData] = useState(QuickActions)

  return (
    <div className='d-flex justify-content-between pl-8 pr-6 quick-actions bg-light'>
      <div className='d-flex align-items-center overflow-auto hidden-scroll pb-5'>
        {quickActionOrder.map(action => {
          action = quickActionsData.find(a => a.name === action) ?? {}
          return (
            <>
              {(!action.notVisibleTo?.includes(currentUserRole) && currentUserActions[action.name]?.visible) && <div className={`mr-5 bg-white border rounded pl-5 pr-9 py-3 d-flex align-items-center cursor-pointer ${action.class} quick-action-hover`} onClick={handleCheckStoreDependency(action)}>
                <i className={`la ${action.icon} mr-3`} />
                <span className='text-nowrap line-height-normal'>{action.title}</span>
              </div>}
            </>
          )
        })}
      </div>
      <div className={`bg-primary rounded px-4 pt-3 text-white height-2-half ml-4`} id="quickActionDropLink" onClick={() => dispatch(quickActions({ showActionsDropdown: true }))}>
        <i className={`la la-plus`} />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { setting: { calendarSetting }, currentStore, auth, dashboard: { quickAction }, organisation: { organisation } } = state
  return {
    currentStoreId: currentStore.store.id,
    currentUserRole: auth.user.role,
    currentUserActions: auth.user.quick_actions,
    quickActionOrder: auth.user.quick_action_order,
    timeSlotFrequency: calendarSetting.calendar_setting.time_slot_frequency,
    quickAction,
    whatsAppConfig: organisation.add_ons_config?.type?.whatsapp,
    storeSpecificPatients: organisation.preferences?.store_specific_patients,
  }
}

export default connect(mapStateToProps)(QuickActions)